import styled, { css } from 'styled-components';
import constants from 'src/constants';

const { DEVICE } = constants.breakpoint;

export const DesignPickerContainer = styled.div`
  position: absolute;
  top: 10px;
  height: 36px;
  right: 10px;

  @media ${DEVICE.MOBILE} {
    width: 100%;
    text-align: center;
    right: 0;
  }

  @media ${DEVICE.MOBILE_LANDSCAPE} {
    top: 15px;
  }

  @media ${DEVICE.MOBILE_PORTRAIT} {
    /* for notch on iphone */
    top: calc(10px + env(safe-area-inset-top));
  }
`;

const pointerEventsStyle = (isSelected) => {
  const style = isSelected
    ? css`
        pointer-events: none;
      `
    : '';
  return style;
};

export const OriginalDesignButton = styled.div`
  display: inline-block;
  height: 100%;
  padding: 10px;
  background-color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.zircon : theme.colors.white};
  border-radius: 3px 0 0 3px;
  cursor: ${({ isSelected }) => (isSelected ? 'auto' : 'pointer')};
  ${({ isSelected }) => pointerEventsStyle(isSelected)}
`;

export const SavedDesignContainer = styled.div`
  display: inline-block;
  height: 100%;
  border-radius: 0 3px 3px 0;
  background-color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.zircon : theme.colors.white};
  border-left: 1px solid ${({ theme }) => theme.colors.zircon};
  cursor: ${({ isSelected }) => (isSelected ? 'auto' : 'pointer')};
  ${({ isSelected }) => pointerEventsStyle(isSelected)}
`;

export const SavedDesignButton = styled.div`
  display: inline-block;
  padding: 10px;
`;

export const LockIconContainer = styled.div`
  display: inline-block;
  margin-right: 5px;

  svg {
    height: ${({ size }) => size}px;
    width: ${({ size }) => size}px;
  }
`;
